// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Tabs_PageHolder__oEsxB","TabsTitle":"Tabs_TabsTitle__Jdrwv","normal":"Tabs_normal__25s7c","checked":"Tabs_checked__1bCeI"};